export const directionToDestinationSelector = ({directionToDestination}) => directionToDestination